import { DateTime } from 'luxon';
import { BenefitActivationDTO, UpdateBenefitActivationDTO } from 'probonio-shared-ui/api';
import { useCallback } from 'react';
import { DialogState } from '../../../component/dialog';
import { useBenefitContext } from '../BenefitContext';
import { ActivationActionsDialog } from './ActivationActionsDialog';
import { PauseMutationDTO } from './useBulkPauseActivationsMutation';
import { useSinglePauseActivationMutation, useSingleUpdateActivationMutation } from './useSingleActivationMutations';

interface Props {
  dialogState: DialogState;
  employeeId: string;
  activationToStop: BenefitActivationDTO;
  terminationDate?: DateTime;
}

export const SingleEditActivationDialog: React.FC<Props> = ({ dialogState, employeeId, activationToStop, terminationDate }) => {
  const { benefit, customBenefit } = useBenefitContext();

  const updateMutation = useSingleUpdateActivationMutation(employeeId, activationToStop.id);
  const pauseMutation = useSinglePauseActivationMutation(benefit, employeeId, customBenefit?.id);

  const handleDeactivate = useCallback((dto: UpdateBenefitActivationDTO) => updateMutation.mutateAsync(dto), [updateMutation]);

  const handlePause = useCallback((dto: PauseMutationDTO) => pauseMutation.mutateAsync(dto), [pauseMutation]);

  return (
    <ActivationActionsDialog
      dialogState={dialogState}
      translationPrefix="editDialog"
      terminationDate={terminationDate}
      onDeactivate={handleDeactivate}
      onPause={handlePause}
    />
  );
};
